import type { Game } from '@/types/games';
import type { Region } from '@/types/constants';
import { ExploreGamesRow } from '@/app/components/game/layouts/explore-games-row/explore-games-row';
import { toGameViewModels } from '@/logic/games/to-game-view-model';

import './styles/@theme';

type ExplorePageWrapperProps = {
    title: string;
    games: Game[];
    isMobile: boolean;
    region: Region;
};

export const ExplorePageWrapper = ({ title, games, region, isMobile }: ExplorePageWrapperProps) => {
    const adaptedGames = toGameViewModels(games, { region, isMobile });

    return (
        <div data-testid="explore-page-wrapper" className="explore-page-wrapper">
            <h2 className="zone-title-explore">{title}</h2>

            <div>
                {adaptedGames.map((game, gameIndex) => (
                    <ExploreGamesRow key={game.uid} {...game} zoneTitle={title} gameIndex={gameIndex} />
                ))}
            </div>
        </div>
    );
};
